const offlineAlarm = {
  AlarmInfo: "Alarm info",
  Type: "Type",
  faultTime: "Fault time",
  startTime: "Start time",
  endTime: "End time",
  type1: "Device Unplug",
  type2: "Offline Alarm"
} 
export default offlineAlarm